import dayjs from 'dayjs';
import { formatDatetime } from '@/services/date';
import { Text, Tooltip } from '@mantine/core';

export function DateTimeTooltip({ date }: { date: dayjs.ConfigType }) {
  return (
    <Tooltip label={formatDatetime(date)}>
      <Text variant="timestamp">{dayjs(date).fromNow()}</Text>
    </Tooltip>
  );
}
